import { API_BASE, apiFetch, authHeaders, parseApiError } from './apiClient';

async function fetchJson(url, options = {}) {
  const response = await apiFetch(url, options);
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(parseApiError(payload, `Error ${response.status}`));
  }
  return payload ?? {};
}

export function mapCouponFromApi(c) {
  return {
    id: c.id,
    code: c.code || c.idCupon,
    amount: Number(c.amount ?? 0),
    discountType: c.discountType,
    dateStart: c.dateStartIso || (c.dateStart ? new Date(c.dateStart).toISOString() : null),
    dateExpiration:
      c.dateExpirationIso ||
      (c.dateExpiration ? new Date(c.dateExpiration).toISOString() : null),
    dateStartMs: c.dateStart,
    dateExpirationMs: c.dateExpiration,
    minimumPurchase: Number(c.minimumPurchase ?? 0),
    maximumCoupons: c.maximumCoupons ?? 0,
    timePerUser: c.timePerUser ?? 1,
    redemptionCount: c.redemptionCount ?? 0,
    status: c.status || 'active',
    isActive: (c.status || 'active') === 'active',
  };
}

export async function fetchCupones() {
  const payload = await fetchJson(`${API_BASE}/coupons`, {
    headers: authHeaders(),
  });
  const list = Array.isArray(payload?.data) ? payload.data : Array.isArray(payload) ? payload : [];
  return list.map(mapCouponFromApi);
}

export async function createCupon(body) {
  const data = await fetchJson(`${API_BASE}/coupons`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(body),
  });
  return mapCouponFromApi(data);
}

export async function updateCupon(id, body) {
  const data = await fetchJson(`${API_BASE}/coupons/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    headers: authHeaders(),
    body: JSON.stringify(body),
  });
  return mapCouponFromApi(data);
}

export async function deleteCupon(id) {
  return fetchJson(`${API_BASE}/coupons/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    headers: authHeaders(),
  });
}
